// Copyright 2025, University of Maryland, All Rights Reserved
import { RefreshWarningProps } from "../types";

/**
 * Default warning dialog component shown before token refresh
 * Users can customize this by providing their own component via config
 */
export function RefreshWarningDialog({
  minutesUntilExpiry,
  secondsRemaining,
  onRefreshNow,
  onCancel,
}: RefreshWarningProps) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "24px",
          maxWidth: "500px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ marginBottom: "16px" }}>
          <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>
            Session Expiring Soon
          </h2>
        </div>

        <div style={{ marginBottom: "20px", color: "#4b5563" }}>
          <p style={{ margin: "0 0 12px 0" }}>
            Your session will expire in{" "}
            <strong>{minutesUntilExpiry} minute{minutesUntilExpiry !== 1 ? "s" : ""}</strong>.
          </p>
          <p style={{ margin: 0 }}>
            Please save your work. The session will automatically refresh in{" "}
            <strong style={{ color: "#dc2626" }}>{secondsRemaining} second{secondsRemaining !== 1 ? "s" : ""}</strong>.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              backgroundColor: "white",
              color: "#374151",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#f9fafb";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "white";
            }}
          >
            Stay on Page
          </button>
          <button
            onClick={onRefreshNow}
            style={{
              padding: "8px 16px",
              border: "none",
              borderRadius: "6px",
              backgroundColor: "#2563eb",
              color: "white",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#1d4ed8";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#2563eb";
            }}
          >
            Refresh Now
          </button>
        </div>
      </div>
    </div>
  );
}
